import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Select from "react-select";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { AddUser } from "./modal"
import { ResetPassword } from "./resetModal"
import { Footer } from "../../../layout/footer"
import { options } from "../../../api";
import { authCRUD } from "../../../actions/auth"
import { Loading } from "../../constant";

export const UserContent = () => {

  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0)
  const [value, setValue] = useState('')
  const [index, setIndex] = useState(0)
  const [resetUser, setResetUser] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      authCRUD.loadUserList(postsPerPage, nextPage, value).then((resp) => {
        setCount(resp.data.count)
        setData(resp.data.results)
        setPageCount(Math.ceil(resp.data.count / postsPerPage))
      }).finally(() => {})
    }, 2000)

  }, [page, postsPerPage, value, index])

  const handleChangePage = (event) => {
    setData([])
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = selectedOption => {
    setData([])
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0)
  };

  const handleSearch = (event) => {
    setData([])
    setValue(event.target.value)

  }

  const handleActive = (e) => {
    authCRUD.updateUserActive(e).then(() => {
      setIndex(index+1)
    })
  }

  const handleNotActive = (e) => {
    authCRUD.updateUserNotActive(e).then(() => {
      setIndex(index+1)
    })
  }

  return (

    <>
      <AddUser setIndex={setIndex} index={index} />
      <ResetPassword user={resetUser} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">System User</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="#">User</a></li>
                      <li className="breadcrumb-item active">List</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                          <div className="d-flex justify-content-sm-start">
                              <div className="search-box ms-2">
                                  <input type="text" className="form-control search" value={value} onChange={handleSearch} placeholder="Search..."/>
                                  <i className="ri-search-line search-icon"></i>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          <div className="col-auto">
                            <Link to={'/new'} className="btn btn-soft-primary" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg">
                              <i className="bi bi-plus-circle bi-lg"></i> &nbsp; New User
                            </Link>
                          </div>
                          <div className="col-auto">
                            <Link to={'/new'} className="btn btn-soft-info" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg">
                              <i className="bi bi-upload bi-lg"></i> &nbsp; Upload User
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table id="scroll-vertical" className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">Full Name</th>
                          <th data-ordering="true">Username</th>
                          <th data-ordering="true">Email</th>
                          <th data-ordering="true">Role</th>
                          <th data-ordering="true">Created</th>
                          <th data-ordering="true">Status</th>
                          <th className="d-flex justify-content-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          data?.map((dt, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{dt.full_name ? dt.full_name : 'N/A'}</td>
                              <td>{dt.username ? dt.username : 'N/A'}</td>
                              <td>{dt.email ? dt.email : 'N/A'}</td>
                              <td>{dt.role_names ? dt.role_names : 'N/A'}</td>
                              <td>{moment(dt.date_joined).format("D MMM, YYYY")}</td>
                              <td>{dt.is_active ? <span className="badge badge-soft-success">Active</span> : <span className="badge badge-soft-danger">Not Active</span>}</td>
                              <td className="d-flex justify-content-center">
                                <div className="hstack gap-3 fs-15">
                                  {dt.is_active ?
                                    <button title="Block account" onClick={() => handleNotActive(dt.id)} className="btn btn-sm btn-soft-success"><i className="bi bi-lock"></i></button>
                                    :
                                    <button title="Unblock account" onClick={() => handleActive(dt.id)} className="btn btn-sm btn-soft-danger"><i className="bi bi-unlock"></i></button>
                                  }
                                  <button
                                    title="Reset password"
                                    className="btn btn-sm btn-soft-warning"
                                    data-bs-toggle="modal"
                                    data-bs-target=".resetPasswordModal"
                                    onClick={() => setResetUser(dt)}
                                  >
                                    <i className="bi bi-key"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    <div className="row">
                      {!data.length && <Loading/>}
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <p><span>Showing </span><span>{data.length}</span> of <span>{count}</span> entries</p>
                      </div>
                      <div className="col-md-5">

                      </div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select options={options} defaultValue={options[1]} onChange={handleChange} />
                          </div>
                          <div className="col-auto paginate" >
                            <ReactPaginate
                              previousLabel={<i className="las la-angle-double-left la-lg"></i>}
                              nextLabel={<i className="las la-angle-double-right la-lg"></i>}
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Footer />
      </div>
    </>

  )

}